import React, { Component } from "react";
import {
    msalApp,
    requiresInteraction,
    fetchMsGraph,
    isIE,
    GRAPH_ENDPOINTS,
    GRAPH_REQUESTS
} from "./auth-utils";
import { apiHelper } from "./components/lib/ApiHelper";



const useRedirectFlow = isIE()

export default C =>
    class AuthProvider extends Component {
        constructor(props) {
            super(props)

            this.state = {
                account: null,
                error: null,
                profile: null,
                memberOf: null,
                tokenResponse: null,
                authorize: null,
                BiToken: null,
                ADGroups: null
            }
        }

        async acquireToken(request, redirect) {
            return msalApp.acquireTokenSilent(request).catch(error => {
                if (requiresInteraction(error.errorCode)) {
                    return redirect
                        ? msalApp.acquireTokenRedirect(request)
                        : msalApp.acquireTokenPopup(request)
                } else {
                    console.error("Non-interactive error:", error.errorCode)
                }
            })
        }

        async onSignIn(redirect) {
            msalApp
                .loginPopup(GRAPH_REQUESTS.LOGIN)
                .then(function (loginResponse) {
                    window.location.reload()
                })
                .catch(function (error) {
                    //login failure
                    console.error(error)
                })
        }

        onSignOut() {
            msalApp.logout()
        }
        scheduleAppTokenRefresh = async( expirationTime )=> {
            const now = new Date().getTime();
            let delay = expirationTime - now - 5 * 60 * 1000;
            setTimeout(this.appToken, delay);
        }


         appToken=async()=> {
            const tokenResponse = await msalApp.acquireTokenSilent(GRAPH_REQUESTS.LOGIN).catch(error => {
                if (requiresInteraction(error.errorCode)) {
                    return useRedirectFlow
                        ? msalApp.acquireTokenRedirect(GRAPH_REQUESTS.LOGIN,)
                        : msalApp.acquireTokenPopup(GRAPH_REQUESTS.LOGIN,)
                } else {
                    console.error("Non-interactive error:", error.errorCode)
                }
            })

             apiHelper.setToken(tokenResponse.accessToken);
           //  console.info(tokenResponse);
             if (tokenResponse) {
                 this.setState({ tokenResponse })
                 const profile = await fetchMsGraph(
                     GRAPH_ENDPOINTS.ME,
                     tokenResponse.accessToken
                 ).catch(() => {
                     this.setState({
                         error: "Unable to fetch profile."
                     })
                 })

                 if (profile) {
                     //   profile.userPrincipalName = "applprh7@penguinrandomhouse.com";
                     this.setState({
                         profile
                     })
                 }

                 const memberOf = await fetchMsGraph(
                     GRAPH_ENDPOINTS.MEMBEROF,
                     tokenResponse.accessToken
                 ).catch(() => {
                     this.setState({
                         error: "Unable to fetch users."
                     })
                 })

                 const adGroups = memberOf.value.map(t => t.displayName.toLowerCase());
                 if (memberOf) {
                     this.setState({ authorize: true })
                     this.setState({
                         memberOf: memberOf,
                         ADGroups: adGroups.length > 0 ? adGroups : []
                     })
                 }
             }


             this.scheduleAppTokenRefresh(tokenResponse.expiresOn);
        
        }
        async componentDidMount() {
            msalApp.handleRedirectCallback(error => {
                if (error) {
                    const errorMessage = error.errorMessage
                        ? error.errorMessage
                        : "Unable to acquire access token."
                    this.setState({
                        error: errorMessage
                    })
                }
            })

            const account = msalApp.getAccount()
            this.setState({
                account : account
            })

            if (account) {
                 await this.appToken();
               
                this.getToken(account);
            }
        }

      

        scheduleTokenRefresh = expirationTime => {
           const now = new Date().getTime();
           let delay = expirationTime - now - 5 * 60 * 1000;
           setTimeout(() => this.getToken(this.state.account), delay);
        }

        
        getToken = async account => {
                const payload = {
                scopes: ["https://analysis.windows.net/powerbi/api/Report.Read.All"],
                account: account
                }

            const tokenResp = await msalApp
                .acquireTokenSilent(payload)
                .then(response => {
                    this.scheduleTokenRefresh(new Date(response.expiresOn).getTime());
                    return response.accessToken;
                });
         
            this.setState({
                BiToken: tokenResp
            });
        }
        render() {
            return (
                <C
                    {...this.props}
                    account={this.state.account}
                    error={this.state.error}
                    profile={this.state.profile}
                    memberOf={this.state.memberOf}
                    tokenResponse={this.state.tokenResponse}
                    onSignIn={() => this.onSignIn(useRedirectFlow)}
                    onSignOut={() => this.onSignOut()}
                    authorize={this.state.authorize}
                    BiToken={this.state.BiToken}
                    ADGroups={this.state.ADGroups}
                />
            )
        }
    }
